import moment from "moment-timezone";
import type { Meeting } from "@platform/types/platform.types";

/**
 * Returns true when `now` falls within the joinable window for a meeting:
 * from 60 minutes before `start_time` until `end_time`.
 *
 * Mirrors the 60-minute lead window used by `getClosestMeetingToCurrentTime`.
 */
export function isMeetingJoinableNow(meeting: Meeting | null | undefined): boolean {
  if (!meeting?.start_time || !meeting?.end_time) return false;

  const now = moment.utc();
  const joinableFrom = moment(meeting.start_time).subtract(60, "minutes");
  const end = moment(meeting.end_time);

  return now.isSameOrAfter(joinableFrom) && now.isBefore(end);
}

export default isMeetingJoinableNow;
